<template>
  <Modal
    class="create-update-modal"
    :mask-closable="false"
    :closable="false"
    :title="actionText + '分类'"
    v-model="modal">
    <Form ref="handleForm" :model="handleForm" :rules="handleValidate" :label-width="110">
      <Row>
        <Col :sm="24" :xs="24">
          <FormItem label="分类名称:" prop="labelName">
            <Input v-model.trim="handleForm.labelName" placeholder="请输入" maxlength="20"  show-word-limit />
          </FormItem>
        </Col>
        <Col :sm="24" :xs="24">
          <FormItem label="备注:" prop="remark">
            <Input v-model.trim="handleForm.remark" placeholder="请输入" maxlength="50" show-word-limit/>
          </FormItem>
        </Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" @click="hide" :disabled="loading">取消</Button>
      <Button type="primary" :loading="loading" @click="submit">确定</Button>
    </div>
  </Modal>
</template>

<script>
import api from '../../api'

export default {
  name: 'CategoryCreateUpdate',
  data () {
    return {
      modal: false,
      loading: false,
      action: 'create',
      dataIndex: null,
      handleForm: {
        labelId: '',
        labelName: '',
        remark: ''
      },
      handleValidate: {
        labelName: [
          { required: true, whitespace: true, message: '请输入分类名称', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    actionText () {
      return this.action === 'create' ? '新增' : '编辑'
    }
  },
  methods: {
    show (action = 'create', data = {}, index) {
      this.action = action
      if (this.action === 'update') {
        this.handleForm = {
          labelId: data.id,
          labelName: data.labelName,
          remark: data.remark
        }
        this.dataIndex = index
      }
      this.modal = true
    },
    hide () {
      this.$refs['handleForm'].resetFields()
      this.handleForm.labelId = ''
      this.dataIndex = null
      this.loading = false
      this.modal = false
    },
    submit () {
      this.$refs['handleForm'].validate((valid) => {
        if (valid) {
          this.submitForm()
        } else {
          this.$Message.error('请填写必填项目!')
        }
      })
    },
    submitForm () {
      let queryParams = {
        ...this.handleForm
      }
      let submitApi = api.commodity.categoryCreate
      if (this.action === 'update') {
        submitApi = api.commodity.categoryUpdate
      } else {
        delete queryParams.labelId
      }
      this.loading = true
      submitApi(queryParams).then(res => {
        this.$emit('success', this.action, {
          ...queryParams
        }, this.dataIndex)
        this.$Message.success(this.actionText + '成功！')
        this.hide()
      }).catch(err => {
        this.$Message.error(this.actionText + '失败：' + err.message)
      }).then(() => {
        this.loading = false
      })
    }
  }
}
</script>
